const FacebookIcon = (props) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 0.0800781C5.37 0.0800781 0 5.45008 0 12.0801C0 18.0701 4.39 23.0201 10.12 23.9201V16.3101H7.07001V12.8401H10.12V10.1901C10.12 7.18008 11.91 5.52008 14.65 5.52008C15.55 5.53008 16.45 5.61008 17.34 5.76008V8.71008H15.83C15.7 8.69008 15.57 8.69008 15.45 8.71008C14.5 8.80008 13.79 9.64008 13.88 10.5901V12.8401H17.21L16.68 16.3101H13.88V23.9201C19.61 23.0201 24 18.0701 24 12.0801C24 5.45008 18.63 0.0800781 12 0.0800781Z"
        fill="inherit"
      />
    </svg>
  )
}

export default FacebookIcon
